module.exports = __webpack_public_path__ + "img/puzzle2.6a0c3abb.png";